// extracted by mini-css-extract-plugin
module.exports = {"center":"SetInfoForm_center__dZQFy","zipInput":"SetInfoForm_zipInput__QnWXy"};